import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionQuest } from "../../info/quest/list/actionQuests";
export var epicSoundsQuestComplete = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionQuest.Finish; }), tap(function (action) { return utilSound.event(IdEventSoundCore.QuestComplete); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsQuestComplete.ts
// module id = 2410
// module chunks = 3